// FILENAME: frontend/src/pages/wip/WipIndexPage.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import { wipPages } from './wipRegistry.js';

const WipIndexPage = () => {
  return (
    <Box sx={{ maxWidth: 980, mx: 'auto', py: { xs: 2, sm: 3 } }}>
      <Stack spacing={2.5}>
        <Box>
          <Chip label="WIP" size="small" color="warning" sx={{ mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Wireframe Pages
          </Typography>
          <Typography sx={{ color: 'text.secondary', mt: 1 }}>
            Rapid wireframes for new pages. Use these to iterate on layout and mock data before wiring the backend.
          </Typography>
        </Box>

        <Divider />

        {wipPages.length === 0 ? (
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              No WIP pages yet
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              Add a page in frontend/src/pages/wip and register it in wipRegistry.js.
            </Typography>
          </Paper>
        ) : (
          <Stack spacing={2}>
            {wipPages.map((page) => (
              <Paper key={page.path} variant="outlined" sx={{ p: 2.5 }}>
                <Stack spacing={1.5}>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {page.title}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }}>{page.description}</Typography>
                  </Box>
                  <Box>
                    <Button
                      component={RouterLink}
                      to={`/${page.path}`}
                      variant="contained"
                      size="small"
                    >
                      Open page
                    </Button>
                  </Box>
                </Stack>
              </Paper>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default WipIndexPage;
